import './index.css';

import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

import { Provider } from 'react-redux';
import 'tippy.js/dist/tippy.css';
import App from './App';
import configureKonvaEditorStore from './app/Store';
const store = configureKonvaEditorStore();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);
